import { render, staticRenderFns } from "./Navigations.vue?vue&type=template&id=450a4b2b"
import script from "./Navigations.vue?vue&type=script&lang=js"
export * from "./Navigations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports